<template>
  <div>
    <v-list v-for="(param, ind) in eventDateObj.params.changedFields" :key="ind" class="transparent  py-1" :light="false">
      <v-list-tile-content>

        <template v-if="param && param.rows && param.rows.length>0">
          <multiple-changes :param="param"></multiple-changes>
        </template>
        <template v-else>
          <single-change :param="param" :activity="eventDateObj.activity"></single-change>
        </template>

      </v-list-tile-content>
    </v-list>
  </div>
</template>

<script>
import SingleChange from '@/components/timeline/event-details/display/SingleChange'
import MultipleChanges from '@/components/timeline/event-details/display/MultipleChanges'

export default {
  name: "UpdateCase",
  data: () => ({
  }),
  props: ["eventDateObj"],
  components: {
    SingleChange,
    MultipleChanges
  }
}
</script>
